// Aviso «Llegó recomendado»: quién recomendó al cliente y lo que gana él (nunca lo que gana quien recomienda).
// Solo sale si la evaluación de la venta trae `referredBy`; si viene null no se pinta nada.
import { UserPlus } from 'lucide-react';
import { referralRewardText } from '@/domains/retail/admin/promotions/lib/referralPromotionText';
import { useSalePromotionEvaluation } from '../api/useWizardPromotions';
import { REFERRED_BY_NOTICE_LABEL as LABEL } from '../constants';

const lowerFirst = (text: string): string =>
    text.charAt(0).toLocaleLowerCase('es-MX') + text.slice(1);

export function ReferredByNotice({
    sessionId,
    customerName,
}: {
    sessionId: string;
    customerName: string;
}) {
    const referredBy = useSalePromotionEvaluation(sessionId).data?.referredBy;
    if (!referredBy) return null;
    const rewards = [...(referredBy.rewards ?? [])].sort((a, b) =>
        a.promotionName.localeCompare(b.promotionName, 'es-MX'),
    );
    return (
        <section
            aria-label={LABEL}
            className="mb-3 flex min-w-0 flex-col gap-2 rounded-xl border border-promo-soft-border bg-promo-soft px-4 py-3.5 text-promo"
        >
            <div className="flex flex-wrap items-baseline justify-between gap-2">
                <span className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.06em]">
                    <UserPlus className="size-3.5" aria-hidden />
                    {LABEL}
                </span>
                <span className="text-[11px] text-muted-foreground">por {referredBy.name}</span>
            </div>
            {rewards.map((r) => (
                <div key={r.promotionId}>
                    <p className="text-[15px] font-bold">
                        {customerName} gana {lowerFirst(referralRewardText(r.reward))}
                    </p>
                    <p className="text-[11px] text-muted-foreground">Promo «{r.promotionName}»</p>
                </div>
            ))}
        </section>
    );
}
